<template>
    <input type="text"
           @input="$emit('changed', $event.target.value)"
           :value="option[objKey]">
</template>

<script type="text/babel">
export default {
    name: 'CustomInput',
    props: {
        option: {
            type: [Object]
        },
        objKey: {
            type: String
        }
    }
};

</script>

